import type { SVGProps } from 'react';

const SvgFullDataSync = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="full-data-sync">
      <path d="M15.65 13.06a3.6 3.6 0 1 0-3.6-3.61 3.63 3.63 0 0 0 .58 2L3 20.88A14.07 14.07 0 0 1 25.1 5h-3v1.5h4.75a.75.75 0 0 0 .75-.75V1h-1.5v2.87A15.57 15.57 0 0 0 2 22.51a.79.79 0 0 0 .55.42h.13a.8.8 0 0 0 .53-.22l10.48-10.24a3.6 3.6 0 0 0 1.96.59M14.17 8a2.1 2.1 0 1 1 3 3 2.16 2.16 0 0 1-3 0 2.1 2.1 0 0 1 0-3M29.41 8.48a.74.74 0 0 0-.66.2L18.3 18.94a3.7 3.7 0 0 0-4.5.46A3.6 3.6 0 1 0 20 22a3.63 3.63 0 0 0-.58-2L29 10.52a14.07 14.07 0 0 1-13.11 19.13 13.92 13.92 0 0 1-9-3.25h3v-1.5H5.17a.76.76 0 0 0-.75.75v4.75h1.5v-2.86A15.58 15.58 0 0 0 30 8.89a.75.75 0 0 0-.59-.41m-11.58 15a2.16 2.16 0 0 1-3 0 2.11 2.11 0 0 1 0-3 2.1 2.1 0 0 1 1.49-.61 2 2 0 0 1 1.48.61 2.09 2.09 0 0 1 0 3Z" />
    </g>
  </svg>
);

export default SvgFullDataSync;
